export default __webpack_public_path__ + "static/media/songs.74cd2ecd.png";